export default __webpack_public_path__ + "static/media/12-12.d2d99e82.png";